export default __webpack_public_path__ + "static/media/IMG_1854 copie.172ce6e3.jpg";